import React, { memo } from 'react';

import { Box } from '@mui/material';

import { useRegisterStepGate } from '../../../hooks';
import { WizardStep } from '../../../PrepareDisclosuresWizard.constants';

import FeeBaselineNote from './components/FeeBaselineNote';
import FeeToleranceLegend from './components/FeeToleranceLegend';
import FeeTotalsBar from './components/FeeTotalsBar';
import OriginatorCompCard from './components/OriginatorCompCard';
import WizardFeeSections from './components/WizardFeeSections';
import { layoutStyles } from './FeesStep.styles';
import { FeesStepTestIds } from './FeesStep.testIds';
import { useOriginatorCompensation, useWizardFees } from './hooks';

const FeesStep = () => {
  const {
    main,
    totals,
    buckets,
    hasFees,
    isLoading,
    setIsLoading,
    editedSection,
    setEditedSection,
  } = useWizardFees();
  const originator = useOriginatorCompensation();

  useRegisterStepGate(WizardStep.FEES, hasFees);

  return (
    <Box data-testid={FeesStepTestIds.ROOT} sx={layoutStyles}>
      <FeeBaselineNote />
      <FeeTotalsBar totals={totals} />
      <WizardFeeSections
        editedSection={editedSection}
        isLoading={isLoading}
        main={main}
        setEditedSection={setEditedSection}
        setIsLoading={setIsLoading}
      />
      <FeeToleranceLegend buckets={buckets} />
      <OriginatorCompCard originator={originator} />
    </Box>
  );
};

export default memo(FeesStep);
